import React, { useState } from "react";
import moment from "moment";
import { COMPLAINT_CATEGORIES, statusLabel } from "./feedbackUtils";

const categoryLabel = (value) =>
  COMPLAINT_CATEGORIES.find((c) => c.value === value)?.label || value || "";

const fmt = (d) => (d ? moment(d).format("DD MMM YYYY, hh:mm A") : "");

/** My complaints: clinic, subject, status chip, date; tap → history timeline. */
const ComplaintsList = ({ complaints = [], loading, error }) => {
  const [openId, setOpenId] = useState(null);

  if (loading) return <p className="fb_muted fb_center">Loading…</p>;
  if (error)
    return (
      <p className="fb_error" role="alert">
        {error}
      </p>
    );
  if (complaints.length === 0)
    return (
      <p className="fb_muted fb_center">You have not raised any complaints.</p>
    );

  return (
    <ul className="fb_list" aria-label="My complaints">
      {complaints.map((c) => {
        const id = c._id || c.referenceId;
        const open = openId === id;
        const status = String(c.status || "").toUpperCase();
        return (
          <li key={id} className="fb_card fb_complaint">
            <button
              type="button"
              className="fb_complaint_head"
              aria-expanded={open}
              onClick={() => setOpenId(open ? null : id)}
            >
              <div className="fb_complaint_main">
                <div className="fb_complaint_subject">{c.subject}</div>
                <div className="fb_muted">
                  {[c.clinicName, categoryLabel(c.category)]
                    .filter(Boolean)
                    .join(" · ")}
                </div>
                <div className="fb_muted fb_small">
                  {c.referenceId}
                  {c.createdAt ? ` · ${moment(c.createdAt).format("DD MMM YYYY")}` : ""}
                </div>
              </div>
              <span className={`fb_chip fb_chip_${status.toLowerCase()}`}>
                {statusLabel(c.status, c.statusLabel)}
              </span>
            </button>
            {open ? (
              <div className="fb_complaint_body">
                {c.description ? (
                  <p className="fb_complaint_desc">{c.description}</p>
                ) : null}
                {c.resolutionNote ? (
                  <div className="fb_resolution">
                    <div className="fb_label">Outcome</div>
                    <p>{c.resolutionNote}</p>
                  </div>
                ) : null}
                <div className="fb_label">History</div>
                <ol className="fb_timeline">
                  {(c.statusHistory || []).map((h, i) => (
                    <li key={`${h.at || i}-${h.status}`} className="fb_timeline_item">
                      <div className="fb_timeline_status">
                        {statusLabel(h.status)}
                        <span className="fb_muted fb_small"> · {fmt(h.at)}</span>
                      </div>
                      {h.note ? <div className="fb_timeline_note">{h.note}</div> : null}
                    </li>
                  ))}
                </ol>
              </div>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
};

export default ComplaintsList;
